import { render, staticRenderFns } from "./TroubleShooting.vue?vue&type=template&id=07497752&scoped=true&"
import script from "./TroubleShooting.vue?vue&type=script&lang=js&"
export * from "./TroubleShooting.vue?vue&type=script&lang=js&"
import style0 from "./TroubleShooting.vue?vue&type=style&index=0&id=07497752&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07497752",
  null
  
)

export default component.exports